import BaseAccountController from '../../lib/controllers/BaseAccountController';

export default class VisitorPassesController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'Profile'];

	constructor($scope: ng.IScope, Profile: lt.IProfile) {
		super($scope, Profile);
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		// load membership
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}
}
